import { queryOptions } from '@tanstack/react-query';

import { apiClient, apiSiblingUrl } from './client';

import type { components } from './generated/rootApi';

type Schemas = components['schemas'];

/*
 * How the backend wants users authenticated (`GET /api/auth-config`),
 * e.g. {"method":"oidc","authority":"…"}. Public by necessity — it is
 * asked before any login exists. The client id is not part of the
 * answer: it identifies this app towards the issuer and stays with the
 * client (REACT_APP_OIDC_CLIENT_ID).
 */
export const authConfigQueries = {
  config: () =>
    queryOptions({
      queryKey: ['authConfig'],
      queryFn: async () => {
        /* the whole app waits behind this answer, the login page
           included — a hanging backend must yield the error page, not
           an indefinite loading state */
        const { data } = await apiClient.get<Schemas['AuthConfig']>(
          apiSiblingUrl('/auth-config'),
          { timeout: 5000 }
        );
        return data;
      },
      /* one answer per app start: the mode must not flip while the app
         runs, and retries would only delay the simulated fallback */
      staleTime: Infinity,
      retry: false,
    }),
};
